import { Chip as Mui4Chip, ChipProps as Mui4ChipProps } from '@material-ui/core'
import { ChipProps as Mui5ChipProps, default as Mui5Chip } from '@mui/material/Chip'
import { forwardRef } from 'react'
import { Icon } from '../core'
import { useComponentVersion } from '../hooks/useComponentVersion'

export enum OsChipVersion {
  V1 = 1, // MUI4
  V2 = 2, // MUI5 + Stratis UI
}
const V2_CHIP_COLORS = ['info', 'error', 'warning', 'success']
export type ChipProps = Omit<Mui5ChipProps, 'variant' | 'color' | 'size'> & {
  variant?: Mui5ChipProps['variant'] | Mui4ChipProps['variant']
  color?: Mui5ChipProps['color'] | Mui4ChipProps['color']
  size?: Mui5ChipProps['size'] | Mui4ChipProps['size']
}

export const Chip = forwardRef<HTMLDivElement, ChipProps>((props, ref) => {
  let version = useComponentVersion('chip')

  switch (version) {
    case OsChipVersion.V2:
      const mui5Props: Mui5ChipProps = {
        ...props,
        variant: props.variant === 'rounded' ? 'outlined' : (props.variant as Mui5ChipProps['variant']),
        size: props.size === 'large' ? 'medium' : props.size, // The new design does not include size='large'
        color: props.color === 'secondary' || props.color === 'info' ? 'default' : props.color,
        deleteIcon: props.deleteIcon || (
          <div>
            <Icon icon="close_small" />
          </div>
        ), // Default delete icon if not provided
      }
      return <Mui5Chip ref={ref} {...mui5Props}></Mui5Chip>

    default:
      const mui4Props: Mui4ChipProps = {
        ...props,
        variant: props.variant === 'rounded' ? 'default' : (props.variant as Mui4ChipProps['variant']),
        color:
          props.color && V2_CHIP_COLORS.includes(props.color) ? 'default' : (props.color as Mui4ChipProps['color']),
        size: props.size as 'small' | 'medium', // Explicitly cast size to match Mui4ChipProps
      }
      return <Mui4Chip ref={ref} {...mui4Props}></Mui4Chip>
  }
})

// extend the spec
declare module '@mui/material/Chip' {
  interface ChipPropsVariantOverrides {
    rounded: true
  }
  interface ChipPropsSizeOverrides {
    large: true
  }
}
